var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Card',{attrs:{"title":"400来电"}},[_c('call-log-view',{ref:"callLogRef",attrs:{"call-log-id":_vm.id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }